export const Resources = {
  singleSelectOptionLimitWarning: (count: number) => `Maximum of ${count} options reached`,
}
